export var AccountDataType;
(function (AccountDataType) {
    AccountDataType["LOGS"] = "LOGS";
    AccountDataType["METRICS"] = "METRICS";
    AccountDataType["TRACES"] = "TRACES";
    AccountDataType["SIEM"] = "SIEM";
})(AccountDataType || (AccountDataType = {}));
export var AccountTag;
(function (AccountTag) {
    AccountTag["Searchable"] = "Searchable";
    AccountTag["Accessible"] = "Accessible";
    AccountTag["RepositoryAccount"] = "Repository account";
    AccountTag["HasRepository"] = "Has repository";
})(AccountTag || (AccountTag = {}));
export var AccountType;
(function (AccountType) {
    AccountType["Owner"] = "OWNER_ACCOUNT";
    AccountType["Sub"] = "SUB_ACCOUNT";
    AccountType["Security"] = "SECURITY_ACCOUNT";
    AccountType["Timeless"] = "TIMELESS_INDEX";
    AccountType["Metrics"] = "METRICS_ACCOUNT";
    AccountType["Restore"] = "RESTORE_ACCOUNT";
    AccountType["Tracing"] = "TRACING_ACCOUNT";
})(AccountType || (AccountType = {}));
export var PLAN_TYPE;
(function (PLAN_TYPE) {
    PLAN_TYPE["FREE"] = "FREE";
    PLAN_TYPE["TRIAL"] = "TRIAL";
    PLAN_TYPE["LIGHT"] = "LIGHT";
    PLAN_TYPE["STANDARD"] = "STANDARD";
    PLAN_TYPE["PRO"] = "PRO";
    PLAN_TYPE["ENTERPRISE"] = "ENTERPRISE";
})(PLAN_TYPE || (PLAN_TYPE = {}));
export var ACCOUNT_STATES;
(function (ACCOUNT_STATES) {
    ACCOUNT_STATES[ACCOUNT_STATES["BLOCKED"] = 0] = "BLOCKED";
    ACCOUNT_STATES[ACCOUNT_STATES["ACTIVE"] = 1] = "ACTIVE";
})(ACCOUNT_STATES || (ACCOUNT_STATES = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ReadOnly"] = "USER_ROLE_READONLY";
    UserRole["Siem"] = "USER_ROLE_SIEM";
    UserRole["User"] = "USER_ROLE_REGULAR";
    UserRole["Admin"] = "USER_ROLE_ACCOUNT_ADMIN";
    UserRole["Expert"] = "USER_ROLE_RESTORE_ALLOWED";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Suspended"] = "SUSPENDED";
    UserStatus["Pending"] = "PENDING";
    UserStatus["Expired"] = "EXPIRED";
})(UserStatus || (UserStatus = {}));
export var ACCOUNT_CREATION_STATES;
(function (ACCOUNT_CREATION_STATES) {
    ACCOUNT_CREATION_STATES["CREATED"] = "AS_CREATED";
    ACCOUNT_CREATION_STATES["READY"] = "AS_READY";
    ACCOUNT_CREATION_STATES["BASE"] = "AS_BASE";
})(ACCOUNT_CREATION_STATES || (ACCOUNT_CREATION_STATES = {}));
export var LogsSuspensionState;
(function (LogsSuspensionState) {
    LogsSuspensionState["NotSuspended"] = "NOT_SUSPENDED";
    LogsSuspensionState["IndexingSuspended"] = "INDEXING_SUSPENDED";
    LogsSuspensionState["ArchivingSuspended"] = "ARCHIVING_SUSPENDED";
})(LogsSuspensionState || (LogsSuspensionState = {}));
export var SiemOwnerAccountState;
(function (SiemOwnerAccountState) {
    SiemOwnerAccountState["NoSiemAccount"] = "NO_SIEM_ACCOUNT";
    SiemOwnerAccountState["InactiveSiemAccount"] = "INACTIVE_SIEM_ACCOUNT";
    SiemOwnerAccountState["SiemAccountExists"] = "SIEM_ACCOUNT_EXISTS";
})(SiemOwnerAccountState || (SiemOwnerAccountState = {}));
//# sourceMappingURL=accounts.js.map